import { useCallback, useEffect, useState } from "react";
import { Badge, Button, Card, Container, Form, Modal } from "react-bootstrap";
import api from "../../api/axios";

function MessagesHome() {
  const [messages, setMessages] = useState([]);
  const [replyTarget, setReplyTarget] = useState(null);
  const [replyBody, setReplyBody] = useState("");
  const [notice, setNotice] = useState("");

  const loadInbox = useCallback(() => {
    api.get("/messages/inbox").then(({ data }) => setMessages(data)).catch(() => setMessages([]));
  }, []);

  useEffect(() => {
    loadInbox();
  }, [loadInbox]);

  const markRead = async messageId => {
    await api.patch(`/messages/${messageId}/read`);
    await loadInbox();
  };

  const sendReply = async event => {
    event.preventDefault();
    if (!replyTarget || !replyBody.trim()) return;
    await api.post("/messages", {
      receiverId: replyTarget.sender_id,
      subject: replyTarget.subject ? `Re: ${replyTarget.subject.replace(/^Re:\s*/i, "")}` : "Respuesta",
      body: replyBody.trim(),
      parentMessageId: replyTarget.id
    });
    setReplyTarget(null);
    setReplyBody("");
    setNotice("Respuesta enviada.");
  };

  return (
    <Container className="page-band feed-page">
      <h1 className="section-title">Mensajes</h1>
      <p className="muted-copy">Inbox privado asincronico para trades, quedadas y coleccionistas.</p>
      {notice && <div className="inline-page-notice mb-3">{notice}</div>}
      <div className="d-grid gap-3">
        {messages.length === 0 && (
          <Card className="cardora-card">
            <Card.Body>No tienes mensajes privados.</Card.Body>
          </Card>
        )}
        {messages.map(message => (
          <Card className="cardora-card" key={message.id} onClick={() => markRead(message.id)}>
            <Card.Body>
              <div className="d-flex justify-content-between gap-3">
                <div>
                  <strong>{message.sender_name}</strong>
                  <div className="muted-copy">{message.subject || "Sin asunto"}</div>
                </div>
                {!message.read_at && <Badge bg="success">Nuevo</Badge>}
              </div>
              <p className="mb-0 mt-2">{message.body}</p>
              <Button
                size="sm"
                variant="outline-dark"
                className="mt-3"
                onClick={event => {
                  event.stopPropagation();
                  setReplyTarget(message);
                  setReplyBody("");
                }}
              >
                Responder
              </Button>
            </Card.Body>
          </Card>
        ))}
      </div>
      <Modal show={Boolean(replyTarget)} onHide={() => setReplyTarget(null)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Responder a {replyTarget?.sender_name}</Modal.Title>
        </Modal.Header>
        <Form onSubmit={sendReply}>
          <Modal.Body>
            <div className="message-reply-context">
              <strong>{replyTarget?.subject || "Sin asunto"}</strong>
              <p>{replyTarget?.body}</p>
            </div>
            <Form.Control
              as="textarea"
              rows={5}
              value={replyBody}
              onChange={event => setReplyBody(event.target.value)}
              placeholder="Escribe tu respuesta..."
              required
              autoFocus
            />
          </Modal.Body>
          <Modal.Footer>
            <Button variant="outline-dark" onClick={() => setReplyTarget(null)}>Cancelar</Button>
            <Button type="submit" className="btn-cardora">Enviar respuesta</Button>
          </Modal.Footer>
        </Form>
      </Modal>
    </Container>
  );
}

export default MessagesHome;
